import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./Home";
import { CreatePost } from "./CreatePost";
import { EditPost } from "./EditPost";

import { createRoot } from "react-dom/client";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/'
          element={<Home />}
        />
        <Route
          path='/create'
          element={<CreatePost />}
        />
        <Route
          path='/edit/:id'
          element={<EditPost />}
        />
      </Routes>
    </BrowserRouter>
  );
};

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
